import { useState, useRef, useEffect } from 'react'

const useManualProgress = (autoIncrementSpeed = 100) => {
	const [progress, setProgress] = useState<number>(0)
	const [isLoading, setIsLoading] = useState<boolean>(false)
	const intervalRef = useRef<NodeJS.Timeout | null>(null)
	const timeoutRef = useRef<NodeJS.Timeout | null>(null)
	const wasFailed = useRef<boolean>(false) // <- NUEVO

	useEffect(() => {
		return () => {
			if (intervalRef.current) clearInterval(intervalRef.current)
			if (timeoutRef.current) clearTimeout(timeoutRef.current)
		}
	}, [])

	const stopAutoIncrement = () => {
		if (intervalRef.current) {
			clearInterval(intervalRef.current)
			intervalRef.current = null
		}
	}

	const startProgress = () => {
		setProgress(0)
		setIsLoading(true)
		wasFailed.current = false 

		stopAutoIncrement()

		intervalRef.current = setInterval(() => {
			setProgress((prev) => {
				if (prev < 99) {
					const inc = prev < 30 ? 3 : prev < 60 ? 2 : prev < 90 ? 1 : 0.5
					return Math.min(prev + inc, 99)
				}
				return prev
			})
		}, autoIncrementSpeed)

		if (timeoutRef.current) clearTimeout(timeoutRef.current)
		timeoutRef.current = setTimeout(() => {
			if (isLoading && !wasFailed.current) {
				console.warn(
					'Tiempo máximo excedido, completando el progreso automáticamente'
				)
				completeProgress()
			}
		}, 30000)
	}

	const updateProgress = (value: number) => {
		setProgress(Math.min(Math.max(value, 0), 99))
	}

	const completeProgress = async () => {
		stopAutoIncrement()
		setProgress(100)

		await new Promise<void>((res) => setTimeout(res, 300))

		setIsLoading(false)
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current)
			timeoutRef.current = null
		}
	}

	const failProgress = async () => {
		wasFailed.current = true 
		stopAutoIncrement()
		setProgress(0)

		await new Promise<void>((res) => setTimeout(res, 200))

		setIsLoading(false)
		if (timeoutRef.current) {
			clearTimeout(timeoutRef.current)
			timeoutRef.current = null
		}
	}

	return {
		progress,
		isLoading,
		startProgress,
		updateProgress,
		completeProgress,
		failProgress,
		wasFailed: () => wasFailed.current,
	}
}

export default useManualProgress